
export default function HeroSection() {
  return (
    <div className="px-4 py-6">
      {/* Hero Banner */}
      <div className="relative rounded-2xl overflow-hidden mb-6">
        <img
          src="https://www.soumqatar.com/uploads/banners/luxury-auction-hero.jpg"
          alt="مزاد فاخر"
          className="w-full h-48 object-cover object-top"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = 'https://public.readdy.ai/ai/img_res/7dd67565028254143d441b204afed391.jpg';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
        <div className="absolute bottom-4 right-4 left-4">
          <h2 className="text-xl font-bold mb-2">مزاد السيارات الفاخرة</h2>
          <p className="text-sm text-gray-200 mb-3">اكتشف مجموعة حصرية من السيارات الفاخرة</p>
          <button className="bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold text-sm">
            شاهد الآن
          </button>
        </div>
      </div>

      {/* Live Status */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">المزادات المباشرة</h3>
        <div className="flex items-center">
          <div className="w-2 h-2 bg-red-500 rounded-full ml-2 animate-pulse"></div>
          <span className="text-sm text-red-400 font-medium">مباشر</span>
        </div>
      </div>
    </div>
  );
}
